import api from "../instance/axios_instance.ts";

/**
 * Campos garantizados por el backend en GET /admin/panel-stats.
 *
 * Los campos calculados por PanelAdmin (customer_count, credit_count,
 * credit_amount) son inyectados en filteredPanelStats mediante trazabilidad
 * y créditos filtrados; el backend NO los devuelve en este endpoint.
 * Se declaran opcionales para no romper el spread de PanelAdmin.
 */
export interface AdminTableData {
    user_id: number;
    advisor_name: string;
    role_name: string;
    office_id: number;
    office_name: string;
    city_name: string;
    advisor_status: string;
    // Conteos de estado provenientes del backend
    approved: number;
    interested: number;
    contacted: number;
    no_answer: number;
    total_customers: number;
    total_credits: number;
    // Calculados por PanelAdmin en filteredPanelStats (no vienen del backend)
    customer_count?: number;
    credit_count?: number;
    credit_amount?: number;
}

export interface PanelStatsFilters {
    office_id?: number;
    start_date?: string;
    end_date?: string;
    filter_user_id?: number | string;
    customer_office_id?: number | string;
    customer_group_id?: number | string;
    customer_type_id?: number | string;
    disbursement_office_id?: number | string;
    campaign_id?: number | string;
    credit_filter?: string;
}

// Acepta un objeto de filtros (o un office_id numérico por compatibilidad).
// Solo se envían los parámetros con valor, para no ensuciar la query.
const PanelStatsApi = async (
    filters?: PanelStatsFilters | number
): Promise<AdminTableData[]> => {
    try {
        const raw: PanelStatsFilters =
            typeof filters === 'number' ? { office_id: filters } : (filters || {});

        const params: Record<string, unknown> = {};
        Object.entries(raw).forEach(([key, value]) => {
            if (value !== '' && value !== null && value !== undefined) {
                params[key] = value;
            }
        });

        const response = await api.get<AdminTableData[]>('/admin/panel-stats', { params });
        return response.data;
    } catch (error) {
        const mensajeError = error.response?.data?.message;
        throw new Error(mensajeError || 'Error al obtener estadísticas del panel');
    }
}

export default PanelStatsApi;
